import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { CSSProperties, ReactNode } from "react";
import Spinner, { ESpinnerColor, ESpinnerSize } from "../Spinner/Spinner";
import classes from "./Button.module.scss";

export enum EButtonSize {
  SMALL,
  MEDIUM,
  LARGE,
}

export enum EButtonColor {
  PRIMARY,
  SUCCESS,
  DANGER,
}

export enum EButtonType {
  BUTTON = "button",
  SUBMIT = "submit",
}

interface IProps {
  icon?: IconDefinition;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  size?: EButtonSize;
  color?: EButtonColor;
  type?: EButtonType;
  loading?: boolean;
}

const Button: React.FC<IProps> = ({
  icon,
  onClick,
  disabled,
  children,
  className,
  style,
  size,
  color,
  type = EButtonType.BUTTON,
  loading,
}) => {
  const classNames = [classes.Button];
  if (disabled) {
    classNames.push(classes.Disabled);
  }
  if (className) {
    classNames.push(className);
  }

  switch (size) {
    case EButtonSize.SMALL:
      classNames.push(classes.Small);
      break;
    case EButtonSize.LARGE:
      classNames.push(classes.Large);
      break;
    default:
  }

  switch (color) {
    case EButtonColor.SUCCESS:
      classNames.push(classes.Success);
      break;
    case EButtonColor.DANGER:
      classNames.push(classes.Danger);
      break;
    default:
  }

  return (
    <button
      className={classNames.join(" ")}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      style={style}
    >
      {loading ? (
        <Spinner size={ESpinnerSize.SMALL} color={ESpinnerColor.CONTENT} />
      ) : (
        <>
          {icon && <FontAwesomeIcon icon={icon} />} {children}
        </>
      )}
    </button>
  );
};

export default Button;
